//Digital Screen Router

//Landing
const DigitalScreenV1 = () => import(/* webpackChunkName: "DigitalScreenV1" */ '../views/DigitalScreen')
const SPBU = () => import(/* webpackChunkName: "SPBU" */ '../views/SPBU')
const Lifestyle = () => import(/* webpackChunkName: "Lifestyle" */ '../views/Lifestyle')
const Malls = () => import(/* webpackChunkName: "Malls" */ '../views/Malls')
const Airport = () => import(/* webpackChunkName: "Airport" */ '../views/Airport')

//Discovery
const DigitalScreen= () => import(/* webpackChunkName: "DigitalScreen" */ '../views/Discovery/DigitalScreen')
const DigitalSPBU = () => import(/* webpackChunkName: "DigitalSPBU" */ '../views/Discovery/DigitalScreen/SPBU')
const DigitalLifestyle = () => import(/* webpackChunkName: "DigitalLifestyle" */ '../views/Discovery/DigitalScreen/Lifestyle')
const DigitalMalls = () => import(/* webpackChunkName: "DigitalMalls" */ '../views/Discovery/DigitalScreen/Malls')
const DigitalLounge = () => import(/* webpackChunkName: "DigitalLounge" */ '../views/Discovery/DigitalScreen/AirportLounge')

//Detail
const DetailSpbu = () => import(/* webpackChunkName: "DetailSpbu" */ '../views/Detail/SPBU')
const DetailLifestyle = () => import(/* webpackChunkName: "DetailLifestyle" */ '../views/Detail/Lifestyle')
const DetailMall = () => import(/* webpackChunkName: "DetailMall" */ '../views/Detail/Mall')
const DetailAirport = () => import(/* webpackChunkName: "DetailAirport" */ '../views/Detail/Airport')

const DigitalSPBUDetail = () => import(/* webpackChunkName: "DigitalSPBUDetail" */ '../views/Discovery/DigitalScreen/SPBU/Detail')
const DigitalLifestyleDetail = () => import(/* webpackChunkName: "DigitalLifestyleDetail" */ '../views/Discovery/DigitalScreen/Lifestyle/Detail')
const DigitalMallsDetail = () => import(/* webpackChunkName: "DigitalMallsDetail" */ '../views/Discovery/DigitalScreen/Malls/Detail')
const DigitalLoungeDetail = () => import(/* webpackChunkName: "DigitalLoungeDetail" */ '../views/Discovery/DigitalScreen/AirportLounge/Detail')

// Editor Page
const CampaignEditorPage = () => import(/* webpackChunkName: "CampaignEditorPage" */ '../views/CampaignEditor')
const AddMoreCampaign = () => import(/* webpackChunkName: "AddMoreCampaign" */ '../views/CampaignEditor/AddMore')


const DigitalScreenRoute = [
    //v1 start
    {
      path: '/digital-screen',
      name: 'digitalscreenv1',
      component: DigitalScreenV1
    },
    {
      path: '/spbu',
      name: 'spbu',
      component: SPBU
    },
    {
      path: '/detail/spbu/:pub_id',
      name: 'detailspbu',
      component: DetailSpbu
    },
    {
      path: '/lifestyle',
      name: 'lifestyle',
      component: Lifestyle
    },
    {
      path: '/detail/lifestyle/:pub_id',
      name: 'detaillifestyle',
      component: DetailLifestyle
    },
    {
      path: '/malls',
      name: 'malls',
      component: Malls
    },
    {
      path: '/detail/malls/:pub_id',
      name: 'detailmall',
      component: DetailMall
    },
    {
      path: '/airport',
      name: 'airport',
      component: Airport
    },
    {
      path: '/detail/airport/:pub_id',
      name: 'detailairport',
      component: DetailAirport
    },
    //v1 end
    //v2 start
    {
      path: '/digitalscreen',
      name: 'digitalscreen',
      component: DigitalScreen,
      meta: {isDigitalAdmin: true}
    },
    {
      path: '/digital/spbu',
      name: 'digitalspbu',
      component: DigitalSPBU
    },
    {
      path: '/digital/spbu/:pub_id',
      name: 'digitalspbudetail',
      component: DigitalSPBUDetail
    },
    {
      path: '/digital/lifestyle',
      name: 'digitallifestyle',
      component: DigitalLifestyle
    },
    {
      path: '/digital/lifestyle/:pub_id',
      name: 'digitallifestyledetail',
      component: DigitalLifestyleDetail
    },
    {
      path: '/digital/malls/',
      name: 'digitalmalls',
      component: DigitalMalls
    },
    {
      path: '/digital/malls/:pub_id',
      name: 'digitalmallsdetail',
      component: DigitalMallsDetail
    },
    {
      path: '/digital/airport_lounge/',
      name: 'digitallounge',
      component: DigitalLounge
    },
    {
      path: '/digital/airport_lounge/:pub_id',
      name: 'digitalloungedetail',
      component: DigitalLoungeDetail
    },
    //v2 end
    {
      path: '/:id/campaign-editor',
      name: 'campaigneditorpage',
      component: CampaignEditorPage,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/campaign-editor/addmore',
      name: 'addmorecampaign',
      component: AddMoreCampaign,
      meta: { requiresAuth: true },
    },
]

export default DigitalScreenRoute;
